import request from '@/utils/request'

export const listFreight = () => request({ url: '/dkmall/freight', method: 'get' })
export const freightOptions = () => request({ url: '/dkmall/freight/options', method: 'get' })
export const getFreight = id => request({ url: `/dkmall/freight/${id}`, method: 'get' })
export const addFreight = data => request({ url: '/dkmall/freight', method: 'post', data })
export const updateFreight = data => request({ url: '/dkmall/freight', method: 'put', data })
export const deleteFreight = id => request({ url: `/dkmall/freight/${id}`, method: 'delete' })

/** 省市区懒加载：pid=0 返回省；传入省/市 id 返回下级 */
export const freightAreas = (pid = 0) => request({ url: '/dkmall/freight/areas', method: 'get', params: { pid } })
export const freightAreaTree = () => request({ url: '/dkmall/freight/areas/tree', method: 'get' })
export const listFreightRules = (id, params = {}) => request({
  url: `/dkmall/freight/${id}/rules`,
  method: 'get',
  params: {
    keyword: params.keyword || undefined,
    pageNum: params.pageNum || 1,
    pageSize: params.pageSize || 20
  }
})
export const addFreightRule = (id, data) => request({ url: `/dkmall/freight/${id}/rules`, method: 'post', data })
export const updateFreightRule = (id, ruleId, data) => request({ url: `/dkmall/freight/${id}/rules/${ruleId}`, method: 'put', data })
export const deleteFreightRule = (id, ruleId) => request({ url: `/dkmall/freight/${id}/rules/${ruleId}`, method: 'delete' })
